import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Package, Trip } from '@returnmates/client-core/src/graphql/generated/api'
import { getPreviousAddress } from '@returnmates/client-core/src/utils/getPreviousAddress'
import clsx from 'clsx'
import momentTz from 'moment-timezone'
import { memo, useMemo } from 'react'
import { FieldArray } from 'react-final-form-arrays'

import useStyles from './styles'

interface Props {
  currentTrip?: Trip | null
  currentPackage?: Package | null
}

const PreviousCustomerInformation = ({ currentPackage, currentTrip }: Props) => {
  const classes = useStyles()

  const currentAddress = useMemo(() => {
    if (currentPackage) {
      return currentPackage.address
    }

    if (currentTrip) {
      return currentTrip.address
    }
  }, [currentPackage, currentTrip])

  return (
    <div className={classes.scrollContainer}>
      <Table className={classes.table} style={{ minWidth: 800 }}>
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.headerRow}>
            <TableCell className={classes.headerCell}>Date</TableCell>
            <TableCell className={classes.headerCell}>Source</TableCell>
            <TableCell className={classes.headerCell}>Previous Address</TableCell>
            <TableCell className={classes.headerCell}>New Address</TableCell>
            <TableCell className={classes.headerCell}>IP Address</TableCell>
            <TableCell className={classes.headerCell}>User ID</TableCell>
          </TableRow>
        </TableHead>

        <FieldArray name="previousAddresses">
          {({ fields }) => {
            const valuesSortedAsc = [...fields.value].sort(
              (a, b) => Number(a.createdAt) - Number(b.createdAt),
            )

            const valuesSorted = valuesSortedAsc.reverse()

            const fakeCurrentAddress =
              currentAddress && valuesSorted.length > 0
                ? {
                    ...currentAddress,
                    createdAt: valuesSorted[0]?.createdAt,
                    source: valuesSorted[0]?.source,
                  }
                : currentAddress

            const addressesWithCurrent = [fakeCurrentAddress, ...valuesSorted].filter(Boolean)
            return (
              <TableBody>
                {addressesWithCurrent.map((to, index) => {
                  if (index === addressesWithCurrent.length - 1) return null

                  const from = addressesWithCurrent[index + 1]
                  const createdAt = from?.createdAt || '-'
                  const source = from?.source || '-'
                  const ipAddress = from?.ipAddress || '-'
                  const userId = from?.userId || '-'

                  return (
                    <TableRow key={to?.id || index} className={classes.tableRow}>
                      <TableCell className={clsx(classes.bodyCell, classes.noWrapText)}>
                        <p>
                          {createdAt
                            ? momentTz
                                .unix(createdAt)
                                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                                .format('M/D/YY h:mm')
                            : '-'}
                        </p>
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        <p>{source}</p>
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        <p>{getPreviousAddress(from)}</p>
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        <p>{getPreviousAddress(to)}</p>
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        <p>{ipAddress}</p>
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        <p>{userId}</p>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            )
          }}
        </FieldArray>
      </Table>
    </div>
  )
}

export default memo(PreviousCustomerInformation)
